import React from 'react';
import Button from '@mui/material/Button';
import { FormattedMessage } from 'react-intl';
import AddIcon from '@mui/icons-material/Add';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
  btn: {
    alignItems: 'center',
    padding: theme.spacing(0),
    margin: theme.spacing(0, 0, 0, -0.5),
    justifyContent: 'left',
    '& > svg': {
      fontSize: theme.typography.body2.fontSize
    }
  }
}));
type AddCustomLabelProps = {
  onClick: () => void;
  autoSelect: boolean;
};

export const AddCustomLabel: React.FC<AddCustomLabelProps> = ({
  onClick,
  autoSelect
}: AddCustomLabelProps) => {
  const classes = useStyles();
  return (
    <Button
      data-testid="add-custom-label-key-search-btn"
      size="small"
      variant="text"
      className={classes.btn}
      onClick={onClick}
      autoFocus={autoSelect}
    >
      <AddIcon
        color="primary"
        data-testid="add-custom-label-plus-icon"
        fontSize="small"
      />
      <FormattedMessage id="search.facets.customLabel" />
    </Button>
  );
};
